import { handleApiErrors } from '../../../../../core/data-access/http-client/interceptors/error.interceptor';
import { FormInputConfig, AllInputTypes } from '../../../../../../trash/shared/interfaces/form-input-config';
import { FormComponent } from '../../../../../../trash/shared/components/dynamic-form/form/form.component';
import { ErrorOrError } from '../../../../../core/results/error-or/models/error-or-error.model';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { AccountUserService } from '../../services/account-user.service';
import { Subscription, tap, catchError, finalize, Subject } from 'rxjs';
import { ChangeDetectorRef, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { IChangeAccountUserPasswordRequest } from '../../dtos/requests/change-password-account-user.request';
import { ICreateAccountUserResponse } from '../../dtos/responses/create-account-user.response';
import { getIdFormConfig } from '../../../../../../views/pages/adminstration/temp-common/utils';
import { ToastService } from '../../../../../../trash/shared/components/toasters/Toast.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-account-user-change-password',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, DialogModule, ButtonModule, FormsModule, FormComponent, TranslateModule],
  templateUrl: './account-user-change-password.component.html',
  styleUrl: './account-user-change-password.component.scss'
})
export class AccountUserChangePasswordComponent {
  private subscriptions: Subscription[] = [];

  isLoadingActionItem = false;
  form: FormInputConfig[] = [];
  formValues: any = null;
  accountUserId: string | undefined;
  validationErrors: any = {};
  validationEmit = false;
  private searchSubject = new Subject<any>();

  constructor(
    private _accountUserService: AccountUserService,
    public dataObj: DynamicDialogConfig,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef,
    private ref: DynamicDialogRef,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.accountUserId = this.dataObj?.data?.item?.id;
    this.initForm();
    if (this.accountUserId) {
      this.formValues = this.dataObj?.data?.item;
    }
  }

  onFilterSelect(e: any) {
    this.searchSubject.next(e);
  }

  // Initialize the form
  initForm() {
    if (this.accountUserId) {
      this.form = [
        getIdFormConfig(this.dataObj?.data?.item?.id),
        {
          type: AllInputTypes.Password,
          name: 'adminPassword',
          label: this.translate.instant('FORMS.ADMIN_PASSWORD'),
          placeholder: `${this.translate.instant('FORMS.EX')} P@ssw0rd`,
          widthClass: 'col-md-12',
          defaultValue: '',
          validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.ADMIN_PASSWORD')}` }]
        },
        {
          type: AllInputTypes.Password,
          name: 'newPassword',
          label: this.translate.instant('FORMS.NEW_PASSWORD'),
          placeholder: `${this.translate.instant('FORMS.EX')} P@ssw0rd`,
          widthClass: 'col-md-12',
          defaultValue: '',
          validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.NEW_PASSWORD')}` }]
        },
        {
          type: AllInputTypes.Password,
          name: 'confirmNewPassword',
          label: this.translate.instant('FORMS.CONFIRM_NEW_PASSWORD'),
          placeholder: `${this.translate.instant('FORMS.EX')} P@ssw0rd`,
          widthClass: 'col-md-12',
          defaultValue: '',
          validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.CONFIRM_NEW_PASSWORD')}` }]
        }
      ];
    }
  }
  valueChanged(data: any) {
    this.formValues = { ...data };
  }

  onClose(data?: any) {
    this.ref.close(data);
  }
  emitValidation() {
    this.validationEmit = !this.validationEmit;
    this.cdr.detectChanges();
  }

  async submitForm(data: any) {
    // Check if passwords match
    if (data?.newPassword !== data?.confirmNewPassword) {
      this.toastService.showError(this.translate.instant('GENERAL.VALIDATION_ERROR'), this.translate.instant('FORMS.VALIDATION_CONFIRM_PASSWORD'));
      return; // Prevent submission
    }

    this.isLoadingActionItem = true;
    const objData: IChangeAccountUserPasswordRequest = this.prepareDataRequest(data);
    const subscription = (await this._accountUserService.ChangePasswordAccountUser(objData, this.formValues.id))
      .pipe(
        tap((res: any) => {
          this.processActionResponse(res, true);
        }),
        catchError((errors: ErrorOrError[]) => handleApiErrors(errors, this.toastService)),
        finalize(() => {
          this.isLoadingActionItem = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe();
    this.subscriptions.push(subscription);
  }

  private prepareDataRequest(data: any): IChangeAccountUserPasswordRequest {
    return {
      adminPassword: data?.adminPassword,
      newPassword: data?.newPassword
    };
  }
  private processActionResponse(response: any | ICreateAccountUserResponse, isUpdate: boolean) {
    this.toastService.showSuccess(this.translate.instant('GENERAL.SUCCESS'), this.translate.instant('FORMS.PASSWORD_CHANGED_SUCCESSFULLY'));
    this.onClose(true);
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
